export default {
    SET_LOADING_STATE: "admins/SET_LOADING_STATE",

    SET_ADMIN_DATA: "admins/SET_ADMIN_DATA",
    SET_ADMIN_PERMISSION_DATA: "admins/SET_ADMIN_PERMISSION_DATA",
    SET_ALL_PERMISSION_DATA: "admins/SET_ALL_PERMISSION_DATA",
    SET_UNASSIGNED_ADMIN_PERMISSION_DATA: "admins/SET_UNASSIGNED_ADMIN_PERMISSION_DATA",
    SET_ADMIN_DETAIL: "admins/SET_ADMIN_DETAIL",
};
